<template>
  <button class="btn btn-warning mr-3 btn-tab" >test tag</button>
</template>

<script>
export default {
name: "ContactTab.component"
}
</script>

<style scoped>
.btn-tab{
  margin-right: 10px;
  height: 40px;
}
</style>